/* eslint-disable no-undef */

window.Wized = window.Wized || [];
window.Wized.push(async (Wized) => {
  // define calm start buttons
  const startSessionButton = document.querySelector('[wized="session_start"]');
  const study = await Wized.requests.waitFor('get_study');
  console.log('study', study);
  const user = await Wized.requests.waitFor('get_user');
  console.log('user', user);

  startSessionButton.addEventListener('click', async (event) => {
    event.preventDefault();
    var redirect_url = study.data.study.session_page;
    console.log('redirect_url', redirect_url);
    try {
      window.location.href = `${redirect_url}`;
    } catch (error) {
      console.error('Error:', error);
    }
  });
});
